<template>
  <div class="gallery">
    <div class="container">
      <div class="heading" data-aos="fade-right">
        <h2 class="title font-secondary mb-3 fs-40 text-teal-dark text-center">Gallery</h2>
      </div>
      <!-- <div class="row justify-content-center">
        <div class="col-12 col-md-8 col-lg-6">
          <iframe width="100%" class="mb-4" height="275" src="https://www.youtube.com/embed/_b6YeLs5GxQ" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
      </div> -->
      <div class="row justify-content-center">
        <div
          class=""
          v-for="(images, index) in gallery"
          :data-key="index"
          :data-count="images.items.length - 1"
          :key="index"
          :class="images.className"
        >
          <div class="flex-wrap row d-flex justify-content-center">
            <div
              class=""
              v-for="(image, imageIndex) in images.items"
              :key="imageIndex"
              :class="image.class"
            >
              <div class="elevation" :data-aos="image.transition">
                <div class="gallery-item" @click="showPopup(image)">
                  <!-- <v-lazy-image :src=""/> -->
                  <img :src="`${image.th || image.full}&tr=w-600`" />
                  <div class="hover-content">
                    <i class="material-icons">zoom_in</i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="row justify-content-center d-md-flex d-none"> -->
      <!-- <div class="col-md-12 col-lg-10 col-xl-8"> -->
      <!-- <iframe width="100%" height="400" src="https://www.youtube.com/embed/rTU7Zv1OiUw" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe> -->
      <!-- </div> -->
      <!-- </div> -->
    </div>

    <transition name="fade">
      <div class="popup" v-if="preview">
        <div class="popup-wrapper">
          <div class="popup-tools">
            <button class="popup-close" @click="closePopup">
              <i class="material-icons">close</i>
            </button>
          </div>
          <div class="popup-controls">
            <div class="left control" @click="prev">
              <i class="material-icons">chevron_left</i>
            </div>
            <div class="right control" @click="next">
              <i class="material-icons">chevron_right</i>
            </div>
          </div>
          <div class="popup-body">
            <img :src="preview.full" class="img-fluid" />
            <div class="copyright" v-if="preview.copyright">
              <i class="material-icons">camera_alt</i> Taken by
              <a :href="preview.copyright.link || null">{{
                preview.copyright.name
              }}</a>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      slickOpt: {
        slideToShow: 1,
      },
      gallery: [
        {
          className: "col-md-12",
          items: [
            {
              full:
                "https://ik.imagekit.io/aryraditya/ceremonyku/dedut-diah/SA-5508.JPG?ik-sdk-version=javascript-1.4.3&updatedAt=1646665819910",
              transition: "fade-down-right",
              class: "col-6 col-md-4"
            },
            {
              full:
                "https://ik.imagekit.io/aryraditya/ceremonyku/dedut-diah/SA-5471.JPG?ik-sdk-version=javascript-1.4.3&updatedAt=1646665818834",
              transition: "fade-down-right",
              class: "col-6 col-md-4"
            },
            {
              full:
                "https://ik.imagekit.io/aryraditya/ceremonyku/dedut-diah/SA-5423.JPG?ik-sdk-version=javascript-1.4.3&updatedAt=1646665818566",
              transition: "fade-down-right",
              class: "col-12 col-md-4"
            },
            {
              full:
                "https://ik.imagekit.io/aryraditya/ceremonyku/dedut-diah/SA-5387.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1646665816569",
              transition: "fade-down-right",
              class: "col-6 col-md-4"
            },


            {
              full:
                "https://ik.imagekit.io/aryraditya/ceremonyku/dedut-diah/SA-5375.JPG?ik-sdk-version=javascript-1.4.3&updatedAt=1646665815999",
              transition: "fade-down-right",
              class: "col-6 col-md-4"
            },
            {
              full:
                "https://ik.imagekit.io/aryraditya/ceremonyku/dedut-diah/SA-5408.JPG?ik-sdk-version=javascript-1.4.3&updatedAt=1646665817651",
              transition: "fade-down-right",
              class: "col-12 col-md-4"
            },
            {
              full:
                "https://ik.imagekit.io/aryraditya/ceremonyku/dedut-diah/SA-5294.JPG?ik-sdk-version=javascript-1.4.3&updatedAt=1646665813596",
              transition: "fade-down-right",
              class: "col-6 col-md-4 order-md-4"
            },
            {
              full:
                "https://ik.imagekit.io/aryraditya/ceremonyku/dedut-diah/DSCF5531.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1646665812376",
              transition: "fade-down-right",
              class: "col-6 col-md-4 order-md-6"
            },
            {
              full:
                "https://ik.imagekit.io/aryraditya/ceremonyku/dedut-diah/SA-5272.JPG?ik-sdk-version=javascript-1.4.3&updatedAt=1646665813188",
              transition: "fade-down-right",
              class: "col-6 col-md-4 order-md-5"
            },
            {
              full:
                "https://ik.imagekit.io/aryraditya/ceremonyku/dedut-diah/SA-5284.JPG?ik-sdk-version=javascript-1.4.3&updatedAt=1646665813379",
              transition: "fade-down-right",
              class: "col-6 col-md-4"
            },
            {
              full:
                "https://ik.imagekit.io/aryraditya/ceremonyku/dedut-diah/SA-5312.JPG?ik-sdk-version=javascript-1.4.3&updatedAt=1646665813749",
              transition: "fade-down-right",
              class: "col-12 col-md-4"
            },
            {
              full:
                "https://ik.imagekit.io/aryraditya/ceremonyku/dedut-diah/SA-5268.JPG?ik-sdk-version=javascript-1.4.3&updatedAt=1646665813818",
              transition: "fade-down-right",
              class: "col-6 col-md-4"
            },
            {
              full:
                "https://ik.imagekit.io/aryraditya/ceremonyku/dedut-diah/SA-5315.JPG?ik-sdk-version=javascript-1.4.3&updatedAt=1646665814300",
              transition: "fade-down-right",
              class: "col-6 col-md-4"
            },
            {
              full:
                "https://ik.imagekit.io/aryraditya/ceremonyku/dedut-diah/SA-5413.JPG?ik-sdk-version=javascript-1.4.3&updatedAt=1646665817811",
              transition: "fade-down-right",
              class: "col-12 col-md-4"
            },
            {
              full:
                "https://ik.imagekit.io/aryraditya/ceremonyku/dedut-diah/SA-5462.JPG?ik-sdk-version=javascript-1.4.3&updatedAt=1646665818608",
              transition: "fade-down-right",
              class: "col-6 col-md-4"
            },
            {
              full:
                "https://ik.imagekit.io/aryraditya/ceremonyku/dedut-diah/SA-5487.JPG?ik-sdk-version=javascript-1.4.3&updatedAt=1646665819615",
              transition: "fade-down-right",
              class: "col-6 col-md-4"
            },
            {
              full:
                "https://ik.imagekit.io/aryraditya/ceremonyku/dedut-diah/SA-5518.JPG?ik-sdk-version=javascript-1.4.3&updatedAt=1646665820433",
              transition: "fade-down-right",
              class: "col-6 col-md-4"
            },
            {
              full:
                "https://ik.imagekit.io/aryraditya/ceremonyku/dedut-diah/SA-5550.JPG?ik-sdk-version=javascript-1.4.3&updatedAt=1646665821526",
              transition: "fade-down-right",
              class: "col-6 col-md-4"
            },
          ],
        },
      ],
      preview: null,
    };
  },
  mounted() {
    document.addEventListener("keydown", (e) => {
      if (this.preview) {
        if (e.key === "ArrowRight") {
          this.next();
        }
        if (e.key === "ArrowLeft") {
          this.prev();
        }
        if (e.key === "Escape") {
          this.closePopup();
        }
      }
    });
  },
  methods: {
    showPopup(image) {
      this.preview = image;
    },
    closePopup() {
      this.preview = null;
    },
    next() {
      this.preview = this.nextImage;
    },
    prev() {
      this.preview = this.prevImage;
    },
  },
  computed: {
    images() {
      const images = [];

      this.gallery.forEach((items) => {
        images.push(...items.items);
      });

      return images;
    },
    currentIndex() {
      return this.preview.full
        ? this.images.map((item) => item.full).indexOf(this.preview.full)
        : null;
    },
    nextImage() {
      let index = this.currentIndex + 1;
      if (index > this.images.length - 1) {
        index = 0;
      }
      return this.currentIndex !== null ? this.images[index] : null;
    },
    prevImage() {
      let index = this.currentIndex - 1;
      if (index < 0) {
        index = this.images.length - 1;
      }
      return this.currentIndex !== null ? this.images[index] : null;
    },
  },
  watch: {
    preview() {
      if (this.preview === null) {
        document.querySelector("body").style.overflowY = null;
      } else {
        document.querySelector("body").style.overflowY = "hidden";
      }
    },
  },
};
</script>

<style type="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
